import * as n from "fp-ts/lib/Option";
import { m as t } from "./vendor-DWc995QB.mjs";
function s(o) {
  const r = n.fold(() => t.None(), t.Maybe.of)(o);
  return Object.assign(r, o);
}
export {
  s as o
};
//# sourceMappingURL=overloadOption-BYdi7V3F.mjs.map
